export type EducationModuleScorePresentation =
  | {
      basis_points: number | null;
      points: number | null;
      points_possible: number | null;
    }
  | null
  | undefined;

const hasValidPointsPair = (
  score: Exclude<EducationModuleScorePresentation, null | undefined>
): score is {
  basis_points: number | null;
  points: number;
  points_possible: number;
} =>
  score.points !== null &&
  score.points_possible !== null &&
  Number.isFinite(score.points) &&
  Number.isFinite(score.points_possible) &&
  score.points >= 0 &&
  score.points_possible > 0 &&
  score.points <= score.points_possible;

/**
 * Formats only the normalized public score contract. It never reads a raw
 * Bubble percentage and drops an invalid points pair rather than displaying it.
 */
export function formatEducationModuleScore(
  score: EducationModuleScorePresentation,
  locale?: string
): string | null {
  if (
    score === null ||
    score === undefined ||
    score.basis_points === null ||
    !Number.isInteger(score.basis_points) ||
    score.basis_points < 0 ||
    score.basis_points > 10_000
  ) {
    return null;
  }

  const numberFormat = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 });
  const percentage = numberFormat.format(score.basis_points / 100);
  if (!hasValidPointsPair(score)) return `${percentage}%`;

  return `${numberFormat.format(score.points)}/${numberFormat.format(score.points_possible)} (${percentage}%)`;
}
